// removed by extract-text-webpack-plugin
module.exports = {"notification":"Notification__notification___2qupG","fadeIn":"Notification__fadeIn___1Rpht","decoration":"Notification__decoration___13hOK","close":"Notification__close___1tuaJ","message":"Notification__message___36crv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification.scss
// module id = 570
// module chunks = 1